import { LOG_OUT, SIGN_IN,RENOV, LOADING, MFA, VALIDARMFA, SIGN_IN_REPRESENTANTE  } from "../actions/login.actions";

const initialState = {
    data: null,
    token: null,
    autenticado: 'checking',
    errorMsg: null,
    loading: false,
    representante:false

}

const LoginReducer = (state = initialState, action) => {

    switch (action.type) {
        case SIGN_IN:
            return {
                ...state,
                data:action.payload,
                token:action.token,
                autenticado: 'autorizado',
                nombre: action.nombre,
                

            }
        
        case SIGN_IN_REPRESENTANTE:
            return {
                ...state,
                data:action.payload,
                token:action.token,
                autenticado: 'autorizado',
                representante:true
    
            }

        case LOG_OUT:
            return {
                ...state,
                data:null,
                token:null,
                autenticado: 'no-autorizado',
                representante:false

            }
        case RENOV:
            return {
                ...state,
                data:null,
                token:action.payload,
                autenticado: 'autorizado'

            }
        case LOADING:
            return {
                ...state,
                loading: !state.loading

            }
        case MFA:
            return {
                ...state,
                data:action.payload,
                token:action.token,
                representante: action.representante,

                

            }
        case VALIDARMFA:
            return {
                ...state,
                autenticado: 'autorizado',

                

            }
    
        default:
            break;
    }


    return state
}


export default LoginReducer